var /* ARTICLES
-------------------------------------------------- */ _document_querySelectorAll;
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import Swiper from 'swiper';
import { Pagination, Navigation, EffectCreative, Manipulation, Autoplay } from 'swiper/modules';
var block = document.getElementById('banner-bot');
if (block) {
    var checkScroll = function checkScroll() {
        if (window.scrollY === 0) {
            block.classList.remove('hidden');
        }
    };
    window.addEventListener('scroll', checkScroll);
    block.classList.remove('hidden');
    setTimeout(function() {
        block.classList.add('show');
    }, 10);
    block.addEventListener('click', function() {
        block.classList.remove('show');
        setTimeout(function() {
            block.classList.add('hiddenAll');
        }, 500);
    });
}
/* HERO
-------------------------------------------------- */ function countdown(targetDate) {
    var currentDate = new Date();
    var difference = Math.max(targetDate - currentDate, 0);
    var countdown = document.getElementById('countdown');
    if (difference <= 0) {
        countdown.classList.remove('active');
        countdown.remove();
        return;
    }
    var days = Math.floor(difference / (1000 * 60 * 60 * 24));
    var hours = Math.floor(difference % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
    var minutes = Math.floor(difference % (1000 * 60 * 60) / (1000 * 60));
    var seconds = Math.floor(difference % (1000 * 60) / 1000);
    var daysDiv = document.getElementById('days');
    var hoursDiv = document.getElementById('hours');
    var minutesDiv = document.getElementById('minutes');
    var secondsDiv = document.getElementById('seconds');
    var daysDivD = document.getElementById('days-d');
    var hoursDivD = document.getElementById('hours-d');
    var minutesDivD = document.getElementById('minutes-d');
    var secondsDivD = document.getElementById('seconds-d');
    function num_word(value, words) {
        value = Math.abs(value) % 100;
        var num = value % 10;
        if (value > 10 && value < 20) return words[2];
        if (num > 1 && num < 5) return words[1];
        if (num == 1) return words[0];
        return words[2];
    }
    daysDiv.innerHTML = days.toString().padStart(2, '0');
    hoursDiv.innerHTML = hours.toString().padStart(2, '0');
    minutesDiv.innerHTML = minutes.toString().padStart(2, '0');
    secondsDiv.innerHTML = seconds.toString().padStart(2, '0');
    daysDivD.innerHTML = num_word(days, [
        'день',
        'дня',
        'дней'
    ]);
    hoursDivD.innerHTML = num_word(hours, [
        'час',
        'часа',
        'часов'
    ]);
    minutesDivD.innerHTML = num_word(minutes, [
        'минуту',
        'минуты',
        'минут'
    ]);
    secondsDivD.innerHTML = num_word(seconds, [
        'секунду',
        'секунды',
        'секунд'
    ]);
}
var $heroSlider = document.querySelector('[data-hero-slider]');
if ($heroSlider) {
    new Swiper($heroSlider, {
        modules: [
            Navigation,
            EffectCreative,
            Autoplay,
            Pagination
        ],
        speed: 1000,
        grabCursor: true,
        effect: 'creative',
        loop: true,
        creativeEffect: {
            prev: {
                translate: [
                    '-50%',
                    0,
                    -1
                ]
            },
            next: {
                translate: [
                    '100%',
                    0,
                    0
                ]
            }
        },
        autoplay: {
            delay: 6000
        },
        lazyPreloadPrevNext: 1,
        resistance: false,
        followFinger: false,
        preventInteractionOnTransition: true,
        watchSlidesProgress: true,
        observer: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        on: {
            slideChange: function slideChange(swiper) {
                if (document.documentElement.clientWidth < 768) {
                    var element1 = document.querySelector('[data-action="1"]');
                    var element2 = document.querySelector('[data-action="2"]');
                    if (element1) {
                        element1.classList.remove('active');
                        element2.classList.remove('active');
                    }
                } else {
                    if (element11) {
                        if (activeIndex % 2 !== 0) {
                            element11.style.display = '';
                            element21.style.display = 'none';
                            element11.style.opacity = 1;
                            element21.style.opacity = 0;
                        } else {
                            element21.style.display = '';
                            element11.style.display = 'none';
                            element21.style.opacity = 1;
                            element11.style.opacity = 0;
                        }
                    }
                }
                var slideCurrentIndex = this.realIndex;
                console.log(slideCurrentIndex);
                if (slideCurrentIndex == 0 || slideCurrentIndex == 2) {
                    document.body.classList.add('invert');
                } else {
                    document.body.classList.remove('invert');
                }
                var activeIndex = swiper.realIndex + 1; // добавляем 1, чтобы начать отсчет с 1
                // получаем элемент вне слайдера по атрибуту
                var element11 = document.querySelector('[data-action="1"]');
                var element21 = document.querySelector('[data-action="2"]');
                // проверяем, существует ли элемент и отображаем его или скрываем в зависимости от номера слайда
                if (element11) {
                    if (activeIndex % 2 !== 0) {
                        element11.style.display = '';
                        element21.style.display = 'none';
                        element11.style.opacity = 1;
                        element21.style.opacity = 0;
                        element11.style.visibility = 'visible';
                        element21.style.visibility = 'hidden';
                    } else {
                        element21.style.visibility = 'visible';
                        element11.style.visibility = 'hidden';
                        element21.style.display = '';
                        element11.style.display = 'none';
                        element21.style.opacity = 1;
                        element11.style.opacity = 0;
                    }
                }
            },
            slideChangeTransitionEnd: function slideChangeTransitionEnd(swiper) {
                /*if (document.documentElement.clientWidth < 768) {
					const countdown1 = document.querySelector('[data-action="1"]');
					const countdown2 = document.querySelector('[data-action="2"]');
					const activeIndex = swiper.realIndex + 1; 
					const myElement = document.querySelector('.swiper-slide-active .hero__text');


					if(myElement ){
					  const bottomPosition = myElement.offsetTop + myElement.offsetHeight;
					  if(bottomPosition > 201){
						countdown1.style.top = `${bottomPosition + 80}px`
						countdown2.style.top = `${bottomPosition + 80}px`
					  }else{
						countdown2.style.top = `50%`
						countdown1.style.top = `50%`
					  }
					}

					if (countdown1) {
						if (activeIndex % 2 !== 0) { // если номер слайда нечетный
							setTimeout(() => {
								countdown1.classList.add('active');

							  }, "100");
						} else { // если номер слайда четный
							setTimeout(() => {
								countdown2.classList.add('active');

							  }, "100");
						}
					  }
				
				}*/ var countdown1 = document.querySelector('[data-action="1"]');
                var countdown2 = document.querySelector('[data-action="2"]');
                var activeIndex = swiper.realIndex + 1;
                if (countdown1) {
                    if (activeIndex % 2 !== 0) {
                        setTimeout(function() {
                            countdown1.classList.add('active');
                        }, "100");
                    } else {
                        setTimeout(function() {
                            countdown2.classList.add('active');
                        }, "100");
                    }
                }
            },
            afterInit: function afterInit(swiper) {
                if (document.documentElement.clientWidth < 768) {
                    var element1 = document.querySelector('[data-action="1"]');
                    var element2 = document.querySelector('[data-action="2"]');
                    if (element1) {
                        element1.classList.remove('active');
                        element2.classList.remove('active');
                    }
                } else {
                    var element11 = document.querySelector('[data-action="1"]');
                    var element21 = document.querySelector('[data-action="2"]');
                    if (element11) {
                        var activeIndex = swiper.realIndex + 1;
                        if (activeIndex % 2 !== 0) {
                            element11.style.display = '';
                            element21.style.display = 'none';
                            element11.style.opacity = 1;
                            element21.style.opacity = 0;
                        } else {
                            element21.style.display = '';
                            element11.style.display = 'none';
                            element21.style.opacity = 1;
                            element11.style.opacity = 0;
                        }
                    }
                }
                /*setTimeout(() => {
				const countdown = document.getElementById('countdown');
				countdown.classList.add('active');
			  }, "1000");

			if (document.documentElement.clientWidth < 768) {
				const countdown = document.getElementById('countdown');
				console.log(document.querySelector('.swiper-slide-active .hero__text'));
				const myElement = document.querySelector('.hero__text');
				const bottomPosition = myElement.offsetTop + myElement.offsetHeight;
				if(myElement ){
					const bottomPosition = myElement.offsetTop + myElement.offsetHeight;
					if(bottomPosition > 201){

					  countdown.style.top = `${bottomPosition + 80}px`
					}else{
					  countdown.style.top = `50%`
					}
				  }
				
			}*/ var countdownD = document.getElementById('countdown');
                if (countdownD) {
                    countdownD.classList.add('active');
                    var targetDate = new Date(countdownD.getAttribute('data'));
                    setInterval(function() {
                        countdown(targetDate);
                    }, 1000);
                }
            }
        }
    });
}
/* FRACTION
-------------------------------------------------- */ var $fractionSlider = document.querySelectorAll('[data-fraction-slider]');
if ($fractionSlider.length) {
    $fractionSlider.forEach(function($item) {
        var fraction = new Swiper($item.querySelector('.swiper'), {
            modules: [
                Pagination,
                Navigation,
                EffectCreative
            ],
            speed: 1000,
            grabCursor: true,
            effect: 'creative',
            loop: true,
            lazyPreloadPrevNext: 1,
            creativeEffect: {
                prev: {
                    translate: [
                        0,
                        '-50%',
                        -1
                    ]
                },
                next: {
                    translate: [
                        0,
                        '100%',
                        0
                    ]
                }
            },
            resistance: false,
            followFinger: false,
            preventInteractionOnTransition: true,
            watchSlidesProgress: true,
            observer: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
                renderFraction: function(currentClass, totalClass) {
                    return '<span class="'.concat(currentClass, '"></span>/ <span class="').concat(totalClass, '"></span>');
                }
            },
            navigation: {
                nextEl: $item.querySelector('.swiper-button-next'),
                prevEl: $item.querySelector('.swiper-button-prev')
            }
        });
        var link = document.querySelector('#facing-slider-link');
        link === null || link === void 0 ? void 0 : link.addEventListener('click', function() {
            console.log("11111");
            var targetElement = document.getElementById('advantages');
            targetElement.scrollIntoView({
                behavior: 'smooth'
            });
            fraction.slideTo(1);
        });
        var $descriptions = $item.querySelectorAll('[data-slider-description]');
        if ($descriptions.length) {
            fraction.on('slideChange', function() {
                $descriptions.forEach(function($itemDescription, index) {
                    $itemDescription.classList.toggle('-show', index === fraction.realIndex);
                });
            });
        }
    });
}
/* TOWER
-------------------------------------------------- */ var $towerSlider = document.querySelector('[data-tower-slider]');
if ($towerSlider) {
    window.towerSlider = new Swiper($towerSlider.querySelector('.swiper'), {
        modules: [
            Navigation
        ],
        speed: 500,
        effect: 'slide',
        watchSlidesProgress: true,
        observer: true,
        direction: 'horizontal',
        reverseDirection: true,
        initialSlide: Array.from($towerSlider.querySelectorAll('[data-tower-floor-id]')).findIndex(function(item) {
            return item.innerText === $towerSlider.dataset.towerFloorStart;
        }) || 0,
        navigation: {
            nextEl: $towerSlider.querySelector('.swiper-button-next'),
            prevEl: $towerSlider.querySelector('.swiper-button-prev')
        },
        breakpoints: {
            701: {
                direction: 'vertical'
            }
        }
    });
}
/* FLOORS
-------------------------------------------------- */ var $floorSlider = document.querySelector('[data-floor-slider]');
if ($floorSlider) {
    window.floorSlider = new Swiper($floorSlider.querySelector('.swiper'), {
        modules: [
            Navigation
        ],
        slidesPerView: 7,
        speed: 250,
        effect: 'slide',
        watchSlidesProgress: true,
        observer: true,
        direction: 'horizontal',
        navigation: {
            nextEl: $floorSlider.querySelector('.swiper-button-next'),
            prevEl: $floorSlider.querySelector('.swiper-button-prev')
        },
        breakpoints: {
            701: {
                slidesPerView: 11
            },
            901: {
                direction: 'vertical'
            }
        }
    });
}
(_document_querySelectorAll = document.querySelectorAll('[data-slider-articles]')) === null || _document_querySelectorAll === void 0 ? void 0 : _document_querySelectorAll.forEach(function($item) {
    new Swiper($item, {
        modules: [
            Navigation
        ],
        slidesPerView: 1,
        speed: 250,
        effect: 'slide',
        watchSlidesProgress: true,
        observer: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        breakpoints: {
            701: {
                slidesPerView: 3
            }
        }
    });
});
/* BUILDING
-------------------------------------------------- */ var $buildingSlider = document.querySelector('[data-building-slider]');
if ($buildingSlider) {
    window.sliderBuild = new Swiper($buildingSlider.querySelector('.swiper'), {
        modules: [
            Navigation,
            Manipulation
        ],
        slidesPerView: 1,
        speed: 250,
        effect: 'slide',
        watchSlidesProgress: true,
        observer: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        breakpoints: {
            701: {
                slidesPerView: 2
            }
        }
    });
}
/* HOME
-------------------------------------------------- */ var $homeSlider = document.querySelector('[data-slider-home]');
if ($homeSlider) {
    window.sliderHome = new Swiper($homeSlider, {
        modules: [
            Navigation,
            EffectCreative,
            Manipulation
        ],
        speed: 500,
        grabCursor: true,
        effect: 'creative',
        lazyPreloadPrevNext: 1,
        observeParents: true,
        creativeEffect: {
            prev: {
                translate: [
                    '-50%',
                    0,
                    -1
                ]
            },
            next: {
                translate: [
                    '100%',
                    0,
                    0
                ]
            }
        },
        resistance: false,
        followFinger: false,
        preventInteractionOnTransition: true,
        watchSlidesProgress: true,
        observer: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        }
    });
}
/* GALLERY TABS
-------------------------------------------------- */ var $tabsSlider = document.querySelector('[data-gallery-tabs-slider]');
if ($tabsSlider) {
    window.sliderTabs = new Swiper($tabsSlider.querySelector('.swiper'), {
        modules: [
            Pagination,
            Navigation,
            EffectCreative
        ],
        speed: 1000,
        effect: 'creative',
        lazyPreloadPrevNext: 1,
        creativeEffect: {
            prev: {
                translate: [
                    '-50%',
                    0,
                    -1
                ]
            },
            next: {
                translate: [
                    '100%',
                    0,
                    0
                ]
            }
        },
        resistance: false,
        followFinger: false,
        preventInteractionOnTransition: true,
        watchSlidesProgress: true,
        observer: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'fraction',
            renderFraction: function(currentClass, totalClass) {
                return '<span class="'.concat(currentClass, '"></span>/ <span class="').concat(totalClass, '"></span>');
            }
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        }
    });
}
/* FINISH
-------------------------------------------------- */ var $finishSlider = document.querySelector('[data-finishing-slider]');
if ($finishSlider) {
    window.sliderFinish = new Swiper($finishSlider, {
        modules: [
            Pagination,
            Navigation,
            EffectCreative,
            Manipulation
        ],
        speed: 1000,
        grabCursor: true,
        effect: 'creative',
        lazyPreloadPrevNext: 1,
        creativeEffect: {
            prev: {
                translate: [
                    0,
                    '-50%',
                    -1
                ]
            },
            next: {
                translate: [
                    0,
                    '100%',
                    0
                ]
            }
        },
        resistance: false,
        followFinger: false,
        preventInteractionOnTransition: true,
        watchSlidesProgress: true,
        observer: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'fraction',
            renderFraction: function(currentClass, totalClass) {
                return '<span class="'.concat(currentClass, '"></span>/ <span class="').concat(totalClass, '"></span>');
            }
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        }
    });
}
/* PARKS SLIDERS
-------------------------------------------------- */ var $parksSlider = document.querySelectorAll('[data-parks-slider]');
var $parksSliderSplide = [];
if ($parksSlider.length) {
    var $parksSliderPrev = document.querySelector('[data-parks-slider-prev]');
    var $parksSliderNext = document.querySelector('[data-parks-slider-next]');
    var parksDisabledControls = function() {
        var sliderInstance = $parksSliderSplide[0];
        if (sliderInstance !== undefined) {
            var length = sliderInstance.length, index = sliderInstance.index;
            $parksSliderPrev.disabled = index + 1 <= 1;
            $parksSliderNext.disabled = index + 1 >= length;
        }
    };
    $parksSlider.forEach(function($item, index) {
        var splide = new Splide($item, {
            type: 'loop',
            drag: 'free',
            focus: 'center',
            gap: '1.6rem',
            pagination: false,
            arrows: false,
            autoWidth: true,
            direction: index === 0 ? 'ltr' : 'rtl',
            autoScroll: {
                speed: 2
            },
            breakpoints: {
                1100: {
                    gap: '1.2rem'
                },
                900: {
                    type: 'slide',
                    drag: false,
                    gap: '0.8rem',
                    autoWidth: false,
                    perPage: 3,
                    direction: 'ltr',
                    autoScroll: false
                },
                700: {
                    perPage: 2
                }
            }
        });
        splide.mount({
            AutoScroll: AutoScroll
        });
        parksDisabledControls();
        splide.on('resize', function() {
            if (window.innerWidth <= 900) {
                splide.go(0);
            }
        });
        splide.on('move', function() {
            parksDisabledControls();
        });
        $parksSliderSplide.push(splide);
    });
    $parksSliderNext.addEventListener('click', function(event) {
        event.preventDefault();
        var step = '1';
        var _$parksSliderSplide_ = $parksSliderSplide[0], length = _$parksSliderSplide_.length, index = _$parksSliderSplide_.index;
        if (window.innerWidth <= 900 && window.innerWidth > 700) {
            if (index === 0 || index === length - 3) {
                step = '2';
            }
        }
        $parksSliderSplide.forEach(function($item) {
            $item.go("+".concat(step));
        });
    });
    $parksSliderPrev.addEventListener('click', function(event) {
        event.preventDefault();
        var step = '1';
        var _$parksSliderSplide_ = $parksSliderSplide[0], length = _$parksSliderSplide_.length, index = _$parksSliderSplide_.index;
        if (window.innerWidth <= 900 && window.innerWidth > 700) {
            if (index === 2 || index === length - 1) {
                step = '2';
            }
        }
        $parksSliderSplide.forEach(function($item) {
            $item.go("-".concat(step));
        });
    });
}
setTimeout(function() {
    var cleanUrlAndAddHome = // setTimeout(() => {
    // 	cleanUrlAndAddHome();
    //   }, "3000");
    function cleanUrlAndAddHome() {
        var currentUrl = window.location.href;
        var cleanUrl = currentUrl.split('#')[0];
        var newUrl = cleanUrl + '#home';
        window.history.pushState(null, '', newUrl);
    };
    var images = document.querySelectorAll('.slider_building img');
    var modal = document.getElementById('modal_img');
    var modalImage = document.getElementById('modal_img-in');
    console.log(images);
    images.forEach(function(image) {
        image.addEventListener('click', function() {
            window.lenis.stop();
            modalImage.src = image.src;
            modal.style.display = 'flex';
        });
    });
    modal.addEventListener('click', function() {
        window.lenis.start();
        modal.style.display = 'none';
        modalImage.src = '';
    });
}, 1000);
